(() => {
  if (customElements.get('sl-review-pages')) return;
  const products = {
    mint: {handle:'energy-gum-mint',name:'Mint gum'},
    berry: {handle:'black-raspberry-energy-gummies-8-packs-32-pieces-copy',name:'Black Raspberry gummies'},
    strawberry: {handle:'strawberry-lemon-energy-gummies',name:'Strawberry Lemon gummies'}
  };
  const extract = root => Array.from(root.querySelectorAll('.jdgm-rev')).map(node => {
    const product = node.querySelector('.jdgm-rev__prod-link');
    const href = product?.getAttribute('href') || '';
    const handle = href.match(/\/products\/([^?#/]+)/)?.[1] || '';
    const originalName = (product || node.querySelector('.jdgm-rev__prod-title'))?.textContent.trim() || '';
    const known = Object.values(products).find(p => p.handle === handle);
    const stamp = node.querySelector('.jdgm-rev__timestamp');
    return {
      id:node.dataset.reviewId, rating:Number(node.querySelector('[data-score]')?.dataset.score || 0),
      handle, productName:known?.name || originalName, productUrl:handle ? '/products/'+handle : '',
      title:node.querySelector('.jdgm-rev__title')?.textContent.trim() || '',
      body:node.querySelector('.jdgm-rev__body')?.textContent.trim() || '',
      author:node.querySelector('.jdgm-rev__author')?.textContent.trim() || '',
      verified:node.dataset.verifiedBuyer === 'true', date:stamp?.dataset.content || stamp?.textContent.trim() || '',
      reply:node.querySelector('.jdgm-rev__reply')?.textContent.trim() || '',
      images:Array.from(node.querySelectorAll('.jdgm-rev__pics img')).map(img=>({
        src:img.getAttribute('data-src') || img.getAttribute('src'),
        href:img.closest('a')?.getAttribute('href') || img.getAttribute('data-src') || img.getAttribute('src')
      })).filter(img=>/^https:\/\//.test(img.src || '') && /^https:\/\//.test(img.href || ''))
    };
  }).filter(r=>r.id && r.rating >= 1 && r.rating <= 5);
  const htmlStrings = value => typeof value === 'string' ? [value] : value && typeof value === 'object' ? Object.values(value).flatMap(htmlStrings) : [];
  class SLReviewPages extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.config = JSON.parse(this.querySelector('[data-review-config]').textContent);
      this.labels = this.config.labels;
      this.scope = 'all'; this.page = 1; this.rating = 'featured'; this.ready = false;
      this.rows = extract(this.querySelector('[data-review-seed]').content);
      this.list = this.querySelector('[data-review-list]');
      this.status = this.querySelector('[data-status]');
      this.nav = this.querySelector('[data-pagination]');
      this.currentButton = this.querySelector('[data-current-product]');
      this.updateProduct();
      const opts = {signal:this.controller.signal};
      this.addEventListener('click', event => {
        const scope = event.target.closest('[data-scope]');
        if (scope) {this.scope = scope.dataset.scope; this.page = 1; this.render(); return;}
        const page = event.target.closest('[data-page]');
        if (page && !page.disabled) {
          this.page = Number(page.dataset.page); this.render();
          this.status.focus({preventScroll:true});
          this.status.scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        }
      }, opts);
      this.querySelector('[data-rating]').addEventListener('change', event => {
        this.rating = event.target.value; this.page = 1; this.render();
      }, opts);
      const update = () => requestAnimationFrame(() => {
        if (!this.isConnected) return;
        const previous = this.product?.handle; this.updateProduct();
        if (previous !== this.product?.handle && this.scope === 'current') {this.page = 1;this.render();}
      });
      document.addEventListener('change',update,opts);
      document.addEventListener('variant:update',update,opts);
      this.querySelector('[data-controls]').hidden = false;
      this.render();
      this.load().catch(error => {
        if (!this.isConnected || this.controller.signal.aborted) return;
        this.dataset.reviewError=error.message; this.failed = true; this.querySelector('[data-error]').hidden = false; this.render();
      });
    }
    updateProduct() {
      const checked = document.querySelector('.sl-flavor-card__input:checked');
      const title = checked?.value || this.config.variants.find(v=>String(v.id) === new URL(location.href).searchParams.get('variant'))?.title || '';
      this.product = title.includes('Strawberry') ? products.strawberry : title.includes('Black Raspberry') ? products.berry : title.includes('Mint') ? products.mint : Object.values(products).find(p=>p.handle === this.dataset.product) || products.mint;
      this.currentButton.textContent = this.labels.product_only.replace('[product]',this.product.name);
    }
    async fetchPage(type,page) {
      const url = new URL('https://cdn.judge.me/reviews/all_reviews_js_based');
      url.searchParams.set('url',this.config.shop);
      url.searchParams.set('platform','shopify');
      url.searchParams.set('sort_by','most-recent');
      url.searchParams.set('shop_domain',this.config.shop);
      url.searchParams.set('page',String(page));
      url.searchParams.set('review_type',type);
      const response = await fetch(url,{signal:this.controller.signal});
      if (!response.ok) throw new Error('Review service HTTP '+response.status);
      const json = await response.json();
      const html = htmlStrings(json).filter(s=>s.includes('jdgm-rev')).join('\n');
      return extract(new DOMParser().parseFromString(html,'text/html'));
    }
    async load() {
      const header = this.querySelector('[data-review-header]').content.querySelector('[data-number-of-reviews]');
      const expectedProducts = Number(header?.dataset.numberOfProductReviews || 0);
      const expectedStore = Number(header?.dataset.numberOfShopReviews || 0);
      const collect = async(type,expected) => {
        if (!expected) return [];
        const first = await this.fetchPage(type,1);
        if (!first.length) throw new Error('Empty review response');
        const pages = Math.ceil(expected/first.length);
        const rest = await Promise.all(Array.from({length:Math.max(0,pages-1)},(_,index)=>this.fetchPage(type,index+2)));
        const unique = new Map([first,...rest].flat().map(row=>[row.id,row]));
        if(unique.size<expected) throw new Error('Incomplete '+type+': '+unique.size+' of '+expected);
        return Array.from(unique.values());
      };
      const batches = await Promise.all([collect('product-reviews',expectedProducts),collect('shop-reviews',expectedStore)]);
      const unique = new Map(batches.flat().map(r=>[r.id,r]));
      if (unique.size < Number(this.dataset.total)) throw new Error('Incomplete reviews');
      this.rows = Array.from(unique.values()).sort((a,b)=>Date.parse(b.date)-Date.parse(a.date));
      this.ready = true; this.render();
    }
    el(tag,className,text) {
      const node = document.createElement(tag); if(className) node.className=className;
      if(text !== undefined) node.textContent=text; return node;
    }
    card(row) {
      const card = this.el('article','sl-review-card');card.dataset.reviewId=row.id;card.dataset.rating=String(row.rating);card.dataset.product=row.handle;
      const top=this.el('div','sl-review-card__top');
      const stars=this.el('span','sl-review-stars','★'.repeat(row.rating)+'☆'.repeat(5-row.rating));
      stars.setAttribute('role','img');stars.setAttribute('aria-label',row.rating===1?this.labels.one_star:this.labels.stars.replace('[score]',row.rating));top.append(stars);
      const date = new Date(row.date);if(!Number.isNaN(date.getTime())){const time=this.el('time','',new Intl.DateTimeFormat(document.documentElement.lang || 'en-US',{month:'short',day:'numeric',year:'numeric'}).format(date));time.dateTime=date.toISOString().slice(0,10);top.append(time);}
      card.append(top);
      const product=this.el(row.productUrl?'a':'span','sl-review-product',row.productName || this.labels.store_review);
      if(row.productUrl) product.href=row.productUrl;card.append(product);
      if(row.title) card.append(this.el('h3','',row.title));
      const body=this.el('p','sl-review-body',row.body.length>360?row.body.slice(0,360).trimEnd()+'…':row.body);card.append(body);
      if(row.body.length>360){const toggle=this.el('button','sl-review-read-more',this.labels.read_more);toggle.type='button';toggle.setAttribute('aria-expanded','false');toggle.addEventListener('click',()=>{const open=toggle.getAttribute('aria-expanded')==='true';body.textContent=open?row.body.slice(0,360).trimEnd()+'…':row.body;toggle.textContent=open?this.labels.read_more:this.labels.read_less;toggle.setAttribute('aria-expanded',String(!open));});card.append(toggle);}
      if(row.images.length){const images=this.el('div','sl-review-media');for(const photo of row.images){const link=this.el('a');link.href=photo.href;link.target='_blank';link.rel='noopener';const img=this.el('img');img.src=photo.src;img.alt=this.labels.customer_photo;img.width=72;img.height=72;img.loading='lazy';link.append(img);images.append(link);}card.append(images);}
      const author=this.el('div','sl-review-card__author',row.author || this.labels.anonymous);
      if(row.verified)author.append(this.el('span','sl-review-verified',this.labels.verified));card.append(author);
      if(row.reply)card.append(this.el('div','sl-review-reply',row.reply));return card;
    }
    render() {
      const filtered=this.rows.filter(row=>(this.scope==='all' || row.handle===this.product.handle) && (this.rating==='all' || this.rating==='featured' && row.rating>=4 || Number(this.rating)===row.rating));
      const total=filtered.length,pages=Math.max(1,Math.ceil(total/10));this.page=Math.min(this.page,pages);
      const first=(this.page-1)*10,last=Math.min(first+10,total);
      this.list.replaceChildren(...filtered.slice(first,last).map(row=>this.card(row)));
      for(const button of this.querySelectorAll('[data-scope]'))button.setAttribute('aria-pressed',String(button.dataset.scope===this.scope));
      const scope=this.scope==='all'?this.labels.all_products:this.product.name;
      const rating=this.rating==='featured'?this.labels.featured:this.rating==='all'?this.labels.all_ratings:this.rating==='1'?this.labels.one_star:this.labels.stars.replace('[score]',this.rating);
      let text=this.ready?(total?this.labels.showing.replace('[first]',first+1).replace('[last]',last).replace('[total]',total):this.labels.empty):this.failed?this.labels.latest:this.labels.loading;
      this.status.textContent=text+' · '+scope+' · '+rating;
      this.nav.replaceChildren();this.nav.hidden=!this.ready || pages<=1;
      if(this.nav.hidden)return;
      const button=(label,page,disabled,current=false)=>{const b=this.el('button','',label);b.type='button';b.dataset.page=String(page);b.disabled=disabled;if(current)b.setAttribute('aria-current','page');return b;};
      this.nav.append(button(this.labels.previous,this.page-1,this.page===1));
      const numbers=[...new Set([1,this.page-1,this.page,this.page+1,pages])].filter(n=>n>0&&n<=pages).sort((a,b)=>a-b);
      let previous=0;for(const n of numbers){if(previous&&n-previous>1)this.nav.append(this.el('span','','…'));const b=button(String(n),n,false,n===this.page);b.setAttribute('aria-label',this.labels.page.replace('[page]',n));this.nav.append(b);previous=n;}
      this.nav.append(button(this.labels.next,this.page+1,this.page===pages));
    }
    disconnectedCallback(){this.controller?.abort();this.controller=null;}
  }
  customElements.define('sl-review-pages',SLReviewPages);
})();
